import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-issue-modal',
  templateUrl: './issue-modal.component.html',
  styleUrls: ['./issue-modal.component.scss']
})
export class IssueModalComponent {


  public title: string = 'SUBMIT ISSUE';
  public closeButtonText: string = 'CLOSE';
  public message: string= '';

  // Used as listener for calling components when modal gets closed;
  // Populate in initial state upon initiating the popup
  public issueModalClosed$; 

  public existingConfigurations: any[] = [];

  constructor(
    public modalRef: BsModalRef) { }

  public closeModal() {
    if(this.issueModalClosed$) {
      this.issueModalClosed$.next();
    }
    this.modalRef.hide();
  }

}
